import React from 'react';
import PropTypes from 'prop-types';
import { STATES } from '../../../constants/App';

/**
 * CommonFields Component
 * Shared form fields used across all quote types (Annuity, Life, LTC)
 */
const CommonFields = ({ formData, onInputChange, styles, formType = 'annuity' }) => {
  const jurisdictionOptions = STATES.map(state => ({
    value: state.value,
    label: state.label
  }));

  // Determine field names based on form type
  const dateOfBirthField = formType === 'annuity' ? 'dateOfBirthAnnuity' : 'dateOfBirthLife';
  const genderField = formType === 'annuity' ? 'genderAnnuity' : 'genderLife';
  const jurisdictionField = formType === 'annuity' ? 'jurisdictionAnnuity' : 'jurisdictionLife';

  return (
    <div style={styles.formGrid}>
      {/* Date of Birth */}
      <div style={styles.formGroup} data-itemid='dob-wrapper'>
        <div style={styles.row} data-itemid='dob-label-wrapper'>
          <label style={styles.label} data-itemid='dob-label'>
            Date of Birth
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='dob-label-required'>
            *
          </label>
        </div>
        <input onChange={e => onInputChange(dateOfBirthField, e.target.value)} placeholder='YYYY-MM-DD' style={styles.input} type='date' value={formData[dateOfBirthField] || ''} data-itemid='dob-input' />
      </div>

      {/* Gender */}
      <div style={styles.formGroup} data-itemid='gender-wrapper'>
        <div style={styles.row} data-itemid='gender-label-wrapper'>
          <label style={styles.label} data-itemid='gender-label'>
            Gender
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='gender-label-required'>
            *
          </label>
        </div>
        <div style={styles.buttonGroup} data-itemid='gender-button-group'>
          {['Male', 'Female'].map(gender => {
            const isSelected = formData[genderField] === gender;
            return (
              <button 
                key={gender} 
                onClick={() => onInputChange(genderField, gender)} 
                style={styles.button(isSelected)} 
                type='button' 
                data-itemid={`gender-button-${gender}`}
                data-selected={isSelected}
                aria-pressed={isSelected}
              >
                {gender}
              </button>
            );
          })}
        </div>
      </div>

      {/* Jurisdiction (State) */}
      <div style={styles.formGroup} data-itemid='jurisdiction-wrapper'>
        <div style={styles.row} data-itemid='jurisdiction-label-wrapper'>
          <label style={styles.label} data-itemid='jurisdiction-label'>
            Jurisdiction
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='jurisdiction-label-required'>
            *
          </label>
        </div>
        <select onChange={e => onInputChange(jurisdictionField, e.target.value)} style={styles.select} value={formData[jurisdictionField] || ''} data-itemid='jurisdiction-select'>
          <option value='' data-itemid='jurisdiction-option-empty'>
            Select State
          </option>
          {jurisdictionOptions.map(state => (
            <option data-itemid={`jurisdiction-option-${state.value}`} key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

CommonFields.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  formType: PropTypes.string
};

export default CommonFields;
